var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._b(
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visibleOnFilter,
            expression: "visibleOnFilter"
          }
        ],
        staticClass: "layout_container_flow"
      },
      "div",
      _vm._d({}, [_vm.state.layoutAttr, true])
    ),
    [
      _c(
        "div",
        { staticClass: "kanban-flow rounded", on: { click: _vm.click } },
        [
          _vm.editFlowName === null
            ? _c("div", [
                _vm.collapsed
                  ? _c("i", { staticClass: "fas fa-angle-right" })
                  : _c("i", { staticClass: "fas fa-angle-down" }),
                _vm._v(" "),
                _vm.state.massSelectionEnabled && this.cards.length
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.checked,
                          expression: "checked"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.checked)
                          ? _vm._i(_vm.checked, null) > -1
                          : _vm.checked
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                        },
                        change: function($event) {
                          var $$a = _vm.checked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.checked = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.checked = $$c
                          }
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.flow.name +
                        (_vm.flow.archived
                          ? " (" + _vm.$t("txtArchived") + ")"
                          : "")
                    ) +
                    "\n      "
                ),
                _c(
                  "div",
                  { staticClass: "float-right" },
                  [
                    _c("i", {
                      staticClass: "fas mr-2",
                      class: {
                        "text-gray-500": _vm.sortBy === "positionNo",
                        [_vm.sortIcon]: true
                      },
                      attrs: {
                        title:
                          _vm.$t("kanban.flow.sortBy.sortedBy") +
                          ": " +
                          _vm.$t("kanban.flow.sortBy." + _vm.sortBy) +
                          " " +
                          _vm.$t("kanban.flow.sortBy." + _vm.sortDirection)
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.cycleSortBy.apply(null, arguments)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.state.settings && _vm.state.settings.advancedUi
                      ? _c("i", {
                          staticClass: "fas fa-exchange-alt mr-2",
                          attrs: { title: _vm.$t("kanbanImportExport") },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.$emit("openPort", {
                                board: _vm.board,
                                flow: _vm.flow
                              })
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canEdit
                      ? _c("i", {
                          staticClass: "fas fa-pen mr-2",
                          class: { disabled: _vm.lockeddown },
                          attrs: { title: _vm.$t("txtRenameFlow") },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.editName.apply(null, arguments)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.flow.archived
                      ? [
                          _vm.canEdit
                            ? _c("i", {
                                staticClass: "fas fa-archive mr-2",
                                class: { disabled: _vm.lockeddown },
                                attrs: { title: _vm.$t("txtArchive") },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.archiveFlow.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              })
                            : _vm._e()
                        ]
                      : [
                          _vm.canEdit
                            ? _c("i", {
                                staticClass: "fas fa-archive mr-2",
                                class: { disabled: _vm.lockeddown },
                                attrs: { title: _vm.$t("txtUnarchive") },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.unarchiveFlow.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                    _vm._v(" "),
                    _vm.canDelete
                      ? _c("i", {
                          staticClass: "fas fa-trash",
                          class: { disabled: _vm.lockeddown },
                          attrs: { title: _vm.$t("txtDeleteFlow") },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.deleteFlow.apply(null, arguments)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  2
                )
              ])
            : _c("div", { staticClass: "input-group mt-1" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editFlowName,
                      expression: "editFlowName"
                    }
                  ],
                  ref: "editflowname",
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.editFlowName },
                  on: {
                    keyup: [
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.renameFlow.apply(null, arguments)
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape"
                          ])
                        )
                          return null
                        $event.preventDefault()
                        $event.stopPropagation()
                        _vm.editFlowName = null
                      }
                    ],
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.editFlowName = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-append" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.renameFlow.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("btnRename")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          _vm.editFlowName = null
                        }
                      }
                    },
                    [_vm._v("\n          ×\n        ")]
                  )
                ])
              ])
        ]
      ),
      _vm._v(" "),
      !_vm.collapsed
        ? _c(
            "div",
            _vm._b(
              { staticClass: "card-inset layout_flow_inset" },
              "div",
              _vm._d({}, [_vm.state.layoutAttr, true])
            ),
            [
              _c(
                "draggable",
                _vm._b(
                  _vm._b(
                    {
                      staticClass: "layout_flow_inset2",
                      attrs: {
                        tag: "div",
                        group: "card",
                        handle: ".kanban-card",
                        delay: "1000",
                        "delay-on-touch-only": "true",
                        move: _vm.canMove
                      },
                      on: {
                        start: function($event) {
                          _vm.drag = true
                        },
                        end: function($event) {
                          _vm.drag = false
                        }
                      },
                      model: {
                        value: _vm.cards,
                        callback: function($$v) {
                          _vm.cards = $$v
                        },
                        expression: "cards"
                      }
                    },
                    "draggable",
                    _vm._d({}, [_vm.state.layoutAttr, true])
                  ),
                  "draggable",
                  _vm.dragOptions,
                  false
                ),
                [
                  _c(
                    "transition-group",
                    {
                      attrs: {
                        type: "transition",
                        tag: "div",
                        name: !_vm.drag ? "flip-list" : null
                      }
                    },
                    _vm._l(_vm.cards, function(card) {
                      return _c("kanban-card", {
                        key: card.id,
                        ref: "kanbanCard",
                        refInFor: true,
                        attrs: {
                          state: _vm.state,
                          board: _vm.board,
                          flow: _vm.flow,
                          card: card
                        },
                        on: {
                          reload: function($event) {
                            return _vm.$emit("reload")
                          },
                          openCard: function($event) {
                            return _vm.$emit("openCard", $event)
                          }
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.state.archived && !_vm.isInbox
                ? _c(
                    "div",
                    _vm._b(
                      { staticClass: "kanban-flow-options-parent" },
                      "div",
                      _vm._d({}, [_vm.state.layoutAttr, true])
                    ),
                    [
                      _c("div", { staticClass: "kanban-flow-options" }, [
                        _c("div", {}, [
                          _vm.newCard === null
                            ? _c("i", {
                                staticClass: "fas fa-plus",
                                attrs: {
                                  title: _vm.$t("txtNewCard"),
                                  "data-v-step": "newcard"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    _vm.newCard = ""
                                    _vm.$nextTick(function() {
                                      _vm.$refs.newcard.focus()
                                    })
                                  }
                                }
                              })
                            : _c("div", { staticClass: "input-group mt-1" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newCard,
                                      expression: "newCard"
                                    }
                                  ],
                                  ref: "newcard",
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: { value: _vm.newCard },
                                  on: {
                                    keyup: [
                                      function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.createCard.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "esc",
                                            27,
                                            $event.key,
                                            ["Esc", "Escape"]
                                          )
                                        )
                                          return null
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        _vm.newCard = null
                                      }
                                    ],
                                    input: function($event) {
                                      if ($event.target.composing) return
                                      _vm.newCard = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-group-append" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-success",
                                        attrs: { type: "button" },
                                        on: { click: _vm.createCard }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("btnCreate")) +
                                            "\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-secondary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            _vm.newCard = null
                                          }
                                        }
                                      },
                                      [_vm._v("×")]
                                    )
                                  ]
                                )
                              ])
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }